import store from "../store";
import { actionTypes } from "./saga";

/**
 * @module SupportSaga
 */

/**
 * Files a new support ticket. `navigate` (from useNavigate) is called with
 * the new ticket's route once it's known.
 * @param {{name: string, description?: string, username?: string, attachmentName?: string}} payload
 * @param {Function} [navigate]
 */
export function submitSupportRequest(payload, navigate) {
  store.dispatch({
    type: actionTypes.SUBMIT_SUPPORT_REQUEST,
    payload: { payload, navigate }
  });
}

export function fetchSupportRequests() {
  store.dispatch({
    type: actionTypes.FETCH_SUPPORT_REQUESTS
  });
}

export function fetchSupportRequestComments(workItemId) {
  store.dispatch({
    type: actionTypes.FETCH_SUPPORT_REQUEST_COMMENTS,
    payload: { workItemId }
  });
}

export function addSupportRequestComment(workItemId, text, username) {
  store.dispatch({
    type: actionTypes.ADD_SUPPORT_REQUEST_COMMENT,
    payload: { workItemId, text, username }
  });
}

export function closeSupportRequest(workItemId) {
  store.dispatch({
    type: actionTypes.CLOSE_SUPPORT_REQUEST,
    payload: { workItemId }
  });
}

export function reopenSupportRequest(workItemId) {
  store.dispatch({
    type: actionTypes.REOPEN_SUPPORT_REQUEST,
    payload: { workItemId }
  });
}
